import {
  CircularProgress,
  LinearProgress,
  Box,
  Typography,
} from "@mui/material";

export const LoadingProgress = ({ loadedCount, totalToLoad }) => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <CircularProgress size={60} />
      <Typography sx={{ mt: 2 }}>
        Loaded {loadedCount} of {totalToLoad} data sources...
      </Typography>
      <LinearProgress
        variant="determinate"
        value={(loadedCount / totalToLoad) * 100}
        sx={{
          mt: 2,
          height: 10,
          borderRadius: 5,
        }}
      />
    </Box>
  );
};
